module.exports = __webpack_public_path__ + "img/form_2.d3b68d02.png";